export default {
  fetchTrafficSources({ commit, state }, refresh) {
    if (state.trafficSources.length > 0 && !refresh) {
      return state.trafficSources;
    }
    return this.$api.adnet.get(`/dict/traffic-source`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_TRAFFIC_SOURCES', response);
      return response;
    });
  },
  fetchRequestFormatTypes({ commit, state }, refresh) {
    if (state.requestFormatTypes.length > 0 && !refresh) {
      return state.requestFormatTypes;
    }
    return this.$api.adnet.get(`/dict/request-format-types`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_REQUEST_FORMAT_TYPES', response);
      return response;
    });
  },
  fetchSspRequestTypes({ commit, state }, refresh) {
    if (state.sspRequestTypes.length > 0 && !refresh) {
      return state.sspRequestTypes;
    }
    return this.$api.adnet.get(`/dict/ssp-request-types`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_SSP_REQUEST_TYPES', response);
      return response;
    });
  },
  fetchBidFormatTypes({ commit, state }, refresh) {
    if (state.bidFormatTypes.length > 0 && !refresh) {
      return state.bidFormatTypes;
    }
    return this.$api.adnet.get(`/dict/bid-format-types`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_BID_FORMAT_TYPES', response);
      return response;
    });
  },
  fetchSSPBidFormatTypes({ commit, state }, refresh) {
    if (state.sspBidFormatTypes.length > 0 && !refresh) {
      return state.sspBidFormatTypes;
    }
    return this.$api.adnet.get(`/dict/ssp-bid-format-types`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_SSP_BID_FORMAT_TYPES', response);
      return response;
    });
  },
  fetchRepeatTypes({ commit, state }, refresh) {
    if (state.repeatTypes.length > 0 && !refresh) {
      return state.repeatTypes;
    }
    return this.$api.adnet.get(`/dict/campaign-repeat-types`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_REPEAT_TYPES', response);
      return response;
    });
  },
  fetchFeedProtocols({ commit, state }, refresh) {
    if (state.feedProtocols.length > 0 && !refresh) {
      return state.feedProtocols;
    }
    return this.$api.adnet.get(`/dict/feed-protocols`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_FEED_PROTOCOLS', response);
      return response;
    });
  },
  fetchSSPFeedProtocols({ commit, state }, refresh) {
    if (state.sspFeedProtocols.length > 0 && !refresh) {
      return state.sspFeedProtocols;
    }
    return this.$api.adnet.get(`/dict/ssp-feed-protocols`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_SSP_FEED_PROTOCOLS', response);
      return response;
    });
  },
  fetchNotifyTypes({ commit, state }, refresh) {
    if (state.notifyTypes.length > 0 && !refresh) {
      return state.notifyTypes;
    }
    return this.$api.adnet.get(`/dict/notify-types`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_NOTIFY_TYPES', response);
      return response;
    });
  },
  fetchAdTags: (function () {
    let pending = null;

    return function ({ commit, state }, data = {}) {
      if (pending) {
        return pending;
      }

      if (state.adTags.length > 0 && !data.refresh) {
        return state.adTags;
      }

      const params = data.params ? { params: { ...data.params } } : {};

      pending = this.$api.adnet.get(`/dict/ad-tags`, params).then((res) => {
        const response = res === null ? [] : res;
        commit('SET_AD_TAGS', response);
        return response;
      }).finally(() => { pending = null; });

      return pending;
    };
  })(),
  fetchCampaignRejectReasons: (function () {
    let isGoing = null;

    return function ({ commit, state }, data = {}) {
      if (isGoing) {
        return isGoing;
      }

      if (state.campaignRejectReasons.length > 0 && !data.refresh) {
        return state.campaignRejectReasons;
      }

      const params = data.params ? { params: { ...data.params } } : {};

      isGoing = this.$api.adnet.get(`/dsp/campaigns/reject-reasons`, params).then((res) => {
        const response = res === null ? [] : res;
        commit('SET_CAMPAIGN_REJECT_REASONS', response);
        isGoing = null;

        return response;
      });

      return isGoing;
    };
  })(),
  fetchCreativeRejectReasons({ commit, state }, data = {}) {
    if (state.creativeRejectReasons.length > 0 && !data.refresh) {
      return state.creativeRejectReasons;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dsp/creatives/reject-reasons`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_CREATIVE_REJECT_REASONS', response);
      return response;
    });
  },
  fetchLandingRejectReasons({ commit, state }, data = {}) {
    if (state.landingRejectReasons.length > 0 && !data.refresh) {
      return state.landingRejectReasons;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dsp/landings/reject-reasons`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_LANDING_REJECT_REASONS', response);
      return response;
    });
  },
  fetchLandingPlaceholders({ commit, state }, data = {}) {
    if (state.placeholders.length > 0 && !data.refresh) {
      return state.placeholders;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dsp/landings/placeholders`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_PLACEHOLDERS', response);
      return response;
    });
  },

  fetchCreativesStatuses({ state }) {
    return state.creativesStatuses;
  },
  fetchLandingStatuses({ commit, state }, data = {}) {
    if (state.landingStatuses.length > 0 && !data.refresh) {
      return state.landingStatuses;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dsp/landings/statuses`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_LANDING_STATUSES', response);
      return response;
    });
  },
  fetchCampaignStatuses({ commit, state }, data = {}) {
    if (state.campaignStatuses.length > 0 && !data.refresh) {
      return state.campaignStatuses;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dsp/campaigns/statuses`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_CAMPAIGN_STATUSES', response);
    });
  },
  fetchDirectDealsStatuses({ commit, state }, data = {}) {
    if (state.directDealsStatuses.length > 0 && !data.refresh) {
      return state.directDealsStatuses;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/dict/direct-deal/statuses', params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_DIRECT_DEALS_STATUSES', response);
      return response;
    });
  },
  fetchLandingDistributionAlgorithms({ commit, state }, data = {}) {
    if (state.landingsDistribution.length > 0 && !data.refresh) {
      return state.landingsDistribution;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dsp/landings/distribution-algorithms`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_LANDINGS_DISTRIBUTION', response);
      return response;
    });
  },
  fetchContentTypes({ commit, state }, refresh) {
    if (state.contentTypes.length > 0 && !refresh) {
      return state.contentTypes;
    }
    return this.$api.adnet.get(`/ssp/content-types`).then((res) => {
      const response = res.list === null ? [] : res.list;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.contentTypes.length > 0) {
        return state.contentTypes;
      }
      commit('SET_CONTENT_TYPES', response);
      return response;
    });
  },
  fetchAdvertCreativeTags({ commit, state }, data = {}) {
    if (Object.keys(state.advertCreativeTags).length > 0 && !data.refresh) {
      return state.advertCreativeTags;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dsp/advert-creative-tags`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_ADVERT_CREATIVE_TAGS', response);
      return response;
    });
  },
  fetchAdPositions({ commit, state }, data = {}) {
    if (Object.keys(state.adPositions).length > 0 && !data.refresh) {
      return state.adPositions;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/dict/ad-positions', params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_AD_POSITIONS', response);
      return response;
    });
  },
  fetchBannerDimensions({ commit, state }, data = {}) {
    if (Object.keys(state.bannerDimensions).length > 0 && !data.refresh) {
      return state.bannerDimensions;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/dict/banner-dimensions', params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_BANNER_DIMENSIONS', response);
      return response;
    });
  },
  fetchBudgetDelivery({ commit, state }, data = {}) {
    if (Object.keys(state.budgetDelivery).length > 0 && !data.refresh) {
      return state.budgetDelivery;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/dsp/campaigns/budget-deliveries', params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_BUDGET_DELIVERY', response);
      return response;
    });
  },
  fetchConnectionTypes({ commit, state }, refresh) {
    if (Object.keys(state.connectionTypes).length > 0 && !refresh) {
      return state.connectionTypes;
    }
    return this.$api.adnet.get('/dict/maxmind-connection-types').then((res) => {
      const response = res === null ? [] : res;
      commit('SET_CONNECTION_TYPES', response);
      return response;
    });
  },
  fetchCarriers({ commit, state }, refresh) {
    if (Object.keys(state.carriers).length > 0 && !refresh) {
      return state.carriers;
    }
    return this.$api.adnet.get('/dict/maxmind-carriers').then((res) => {
      const response = res === null ? [] : res;
      commit('SET_CARRIES', response);
      return response;
    });
  },
  fetchTrafficTypesDict({ commit, state }, refresh) {
    if (Object.keys(state.trafficTypesDict).length > 0 && !refresh) {
      return state.trafficTypesDict;
    }
    return this.$api.adnet.get('/dict/traffic-types-dict').then((res) => {
      const response = res === null ? {} : res;
      commit('SET_TRAFFIC_TYPES_DICT', response);
      return response;
    });
  },
  fetchSiteTypes({ commit, state }, refresh) {
    if (Object.keys(state.siteTypes).length > 0 && !refresh) {
      return state.siteTypes;
    }
    return this.$api.adnet.get('/dict/site-types').then((res) => {
      const response = res === null ? {} : res;
      commit('SET_SITE_TYPES', response);
      return response;
    });
  },
  fetchStatuses({ commit, state }, refresh) {
    if (Object.keys(state.statuses).length > 0 && !refresh) {
      return state.statuses;
    }
    return this.$api.adnet.get('/ssp/statuses').then((res) => {
      const response = res.list === null ? {} : res;
      commit('SET_STATUSES', response);
      return response;
    });
  },
  fetchSiteCategories({ commit, state }, refresh) {
    if (state.siteCategories.length > 0 && !refresh) {
      return state.siteCategories;
    }
    return this.$api.adnet.get('/dict/categories').then((res) => {
      const response = res === null ? [] : res;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.siteCategories.length > 0) {
        return state.siteCategories;
      }
      commit('SET_SITE_CATEGORIES', response);
      return response;
    });
  },
  fetchTrafficTypes({ commit }) {
    return this.$api.adnet.get('/dict/traffic-types').then((res) => {
      commit('SET_TRAFFIC_TYPES', res);
      return res;
    });
  },
  fetchCountries({ commit, state }, refresh) {
    if (state.countries.length > 0 && !refresh) {
      return state.countries;
    }
    return this.$api.adnet.get('/dict/countries').then((res) => {
      const response = res === null ? [] : res;
      const countries = response
        .map((country) => {
          country.name = country.shortName;
          return country;
        })
        .filter((el) => el.iso2 !== 'XX');
      // a degraded/empty dict must not overwrite an already loaded list - target hydration maps ids through this and would drop unmatched values.
      // return committed state (not the empty fetch) so return-value consumers stay consistent with the store.
      if (countries.length === 0 && state.countries.length > 0) {
        return state.countries;
      }
      commit('SET_COUNTRIES', countries);
      return countries;
    });
  },
  fetchRegions(store, data = {}) {
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/dict/regions', params).then((res) => {
      return res === null ? [] : res;
    });
  },
  fetchOSTypes({ commit, state }, refresh) {
    if (state.osTypes.length > 0 && !refresh) {
      return state.osTypes;
    }
    return this.$api.adnet.get('/dict/os-types').then((res) => {
      const response = res === null ? [] : res;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.osTypes.length > 0) {
        return state.osTypes;
      }
      commit('SET_OS_TYPES', response);
      return response;
    });
  },
  fetchOSNames({ commit, state }, refresh) {
    if (state.osNames.length > 0 && !refresh) {
      return state.osNames;
    }
    return this.$api.adnet.get('/dict/os').then((res) => {
      const response = res === null ? [] : res;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.osNames.length > 0) {
        return state.osNames;
      }
      commit('SET_OS_NAMES', response);
      return response;
    });
  },
  fetchOsVersions(store, data = {}) {
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get('/dict/os-major-versions', params).then((res) => {
      const response = res === null ? [] : res;
      return response;
    });
  },
  fetchTargetAdunits({ commit }) {
    return this.$api.adnet.get('/targets/adunits', { params: { limit: 9999 } }).then((res) => {
      commit('SET_TARGETS_ADUNITS', res);
      return res;
    });
  },
  fetchLanguagesNames({ commit, state }, refresh) {
    if (state.languages.length > 0 && !refresh) {
      return state.languages;
    }
    return this.$api.adnet.get('/dict/languages').then((res) => {
      const response = res === null ? [] : res;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.languages.length > 0) {
        return state.languages;
      }
      commit('SET_LANGUAGES_NAMES', response);
      return response;
    });
  },
  fetchDeviceTypes({ commit, state }, refresh) {
    if (state.deviceTypes.length > 0 && !refresh) {
      return state.deviceTypes;
    }
    return this.$api.adnet.get('/dict/device-types').then((res) => {
      const response = res === null ? [] : res;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.deviceTypes.length > 0) {
        return state.deviceTypes;
      }
      commit('SET_DEVICE_TYPES', response);
      return response;
    });
  },
  fetchAdunitTypes({ commit, state }, refresh) {
    if (state.adUnitTypes.length > 0 && !refresh) {
      return state.adUnitTypes;
    }
    return this.$api.adnet.get('/dict/adunit-types').then((res) => {
      const response = res === null ? [] : res;
      commit('SET_AD_UNIT_TYPES', response);
      return response;
    });
  },
  fetchAdunitFormats({ commit, state }, { type }) {
    if (state.adunitFormats[type] && state.adunitFormats[type].length > 0) {
      return state.adunitFormats[type];
    }
    if (!type) {
      return [];
    }
    return this.$api.adnet.get(`/dict/adunit-types/${type}/formats`).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_ADUNIT_FORMATS', { list: response, type });
      return response;
    });
  },
  async fetchAllAdunitFormats({ commit, state, dispatch }) {
    await dispatch('fetchAdunitTypes');

    let formats = [];
    await Promise.all(
      state.adUnitTypes.map((el) => {
        return this.$api.adnet.get(`/dict/adunit-types/${el.id}/formats`).then((res) => {
          const response = res === null ? [] : res;
          formats = [...formats, ...response];
          formats.sort((a, b) => a.name.localeCompare(b.name));
          commit('SET_ADUNIT_FORMATS', { list: response, type: el.id });
          return response;
        });
      }),
    );

    return formats;
  },
  fetchBrowsers({ commit }) {
    return this.$api.adnet.get('/dict/browsers').then((res) => {
      commit('SET_BROWSERS', res);
      return res;
    });
  },
  fetchBrowserTypes({ commit, state }, refresh) {
    if (state.browserTypes.length > 0 && !refresh) {
      return state.browserTypes;
    }
    return this.$api.adnet.get('/dict/browser-types').then((res) => {
      const response = res === null ? [] : res;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.browserTypes.length > 0) {
        return state.browserTypes;
      }
      commit('SET_BROWSER_TYPES', response);
      return response;
    });
  },
  fetchCookieTypes({ commit, state }, refresh) {
    if (state.cookieTypes.length > 0 && !refresh) {
      return state.cookieTypes;
    }
    return this.$api.adnet.get('/dict/cookie-types').then((res) => {
      const response = res === null ? [] : res;
      // a degraded/empty refetch must not clobber an already-loaded dict.
      if (response.length === 0 && state.cookieTypes.length > 0) {
        return state.cookieTypes;
      }
      commit('SET_COOKIE_TYPES', response);
      return response;
    });
  },
  fetchDeviceModels({ commit }) {
    return this.$api.adnet.get('/device/models').then((res) => {
      commit('SET_DEVICE_MODELS', res.deviceModels);
    });
  },
  fetchISPs({ commit }) {
    return this.$api.adnet.get('/isps').then((res) => {
      commit('SET_ISPS', res.isps);
    });
  },
  fetchPricingModels({ commit, state }, data = {}) {
    if (!data.adUnitTypeId) {
      return state.pricingModels;
    }
    if (state.pricingModels.length > 0 && !data.refresh) {
      return state.pricingModels;
    }
    const params = data.params ? { params: { ...data.params } } : {};
    return this.$api.adnet.get(`/dict/pricing-models/adunit-types/${data.adUnitTypeId}`, params).then((res) => {
      const response = res === null ? [] : res;
      commit('SET_PRICING_MODELS', response);
      return response;
    });
  },
  fetchTriggerMethods({ commit }) {
    const data = [
      {
        id: 1,
        name: 'Click anywhere',
      },
      {
        id: 2,
        name: 'Click on specific selector',
      },
    ];
    commit('SET_TRIGGER_METHODS', data);
    return data;
  },
  fetchCpaStates({ commit }) {
    return this.$api.adnet.get('/dict/cpa-state').then((res) => {
      commit('SET_CPA_STATES', res);
      return res;
    });
  },
  fetchCpaSpotStates({ commit }) {
    return this.$api.adnet.get('/dict/cpa-spot-state').then((res) => {
      commit('SET_CPA_SPOT_STATES', res);
      return res;
    });
  },
  fetchCpaRuleTypes({ commit }) {
    return this.$api.adnet.get('/dict/cpa-rule-type').then((res) => {
      commit('SET_CPA_RULE_TYPES', res);
      return res;
    });
  },
  fetchCpaConditions({ commit }) {
    return this.$api.adnet.get('/dict/cpa-condition').then((res) => {
      commit('SET_CPA_CONDITIONS', res);
      return res;
    });
  },
  fetchDealTypes({ commit }) {
    return this.$api.adnet.get('/dict/deal-types').then((res) => {
      commit('SET_DEAL_TYPES', res);
      return res;
    });
  },
  fetchBlacklistRuleStates({ commit }) {
    return this.$api.adnet.get('/dict/blacklist-status').then((res) => {
      commit('SET_BLACKLIST_RULE_STATES', res);
      return res;
    });
  },
  fetchBlacklistRuleTypes({ commit }) {
    return this.$api.adnet.get('/dict/blacklist-ban-type').then((res) => {
      commit('SET_BLACKLIST_RULE_TYPES', res);
      return res;
    });
  },
  fetchBlacklistRuleConditions({ commit }) {
    return this.$api.adnet.get('/dict/blacklist-condition').then((res) => {
      commit('SET_BLACKLIST_RULE_CONDITIONS', res);
      return res;
    });
  },
};
